import Page_Acfbuilder_Wrapper_About from 'components/Builder/Page_Acfbuilder_Wrapper_About/Page_Acfbuilder_Wrapper_About';
import Page_Acfbuilder_Wrapper_Blog from 'components/Builder/Page_Acfbuilder_Wrapper_Blog/Page_Acfbuilder_Wrapper_Blog';
import Page_Acfbuilder_Wrapper_BlogWidget1 from 'components/Builder/Page_Acfbuilder_Wrapper_BlogWidget1/Page_Acfbuilder_Wrapper_BlogWidget1';
import Page_Acfbuilder_Wrapper_BlogWidget2 from 'components/Builder/Page_Acfbuilder_Wrapper_BlogWidget2/Page_Acfbuilder_Wrapper_BlogWidget2';
import Page_Acfbuilder_Wrapper_CentersOfExcellence from 'components/Builder/Page_Acfbuilder_Wrapper_CentersOfExcellence/Page_Acfbuilder_Wrapper_CentersOfExcellence';
import Page_Acfbuilder_Wrapper_Clean from 'components/Builder/Page_Acfbuilder_Wrapper_Clean/Page_Acfbuilder_Wrapper_Clean';
import Page_Acfbuilder_Wrapper_Contact1 from 'components/Builder/Page_Acfbuilder_Wrapper_Contact1/Page_Acfbuilder_Wrapper_Contact1';
import Page_Acfbuilder_Wrapper_Contact2 from 'components/Builder/Page_Acfbuilder_Wrapper_Contact2/Page_Acfbuilder_Wrapper_Contact2';
import Page_Acfbuilder_Wrapper_ContactForm from 'components/Builder/Page_Acfbuilder_Wrapper_ContactForm/Page_Acfbuilder_Wrapper_ContactForm';
import Page_Acfbuilder_Wrapper_Content1 from 'components/Builder/Page_Acfbuilder_Wrapper_Content1/Page_Acfbuilder_Wrapper_Content1';
import Page_Acfbuilder_Wrapper_Content10 from 'components/Builder/Page_Acfbuilder_Wrapper_Content10/Page_Acfbuilder_Wrapper_Content10';
import Page_Acfbuilder_Wrapper_Content11 from 'components/Builder/Page_Acfbuilder_Wrapper_Content11/Page_Acfbuilder_Wrapper_Content11';
import Page_Acfbuilder_Wrapper_Content12 from 'components/Builder/Page_Acfbuilder_Wrapper_Content12/Page_Acfbuilder_Wrapper_Content12';
import Page_Acfbuilder_Wrapper_Content13 from 'components/Builder/Page_Acfbuilder_Wrapper_Content13/Page_Acfbuilder_Wrapper_Content13';
import Page_Acfbuilder_Wrapper_Content14 from 'components/Builder/Page_Acfbuilder_Wrapper_Content14/Page_Acfbuilder_Wrapper_Content14';
import Page_Acfbuilder_Wrapper_Content15 from 'components/Builder/Page_Acfbuilder_Wrapper_Content15/Page_Acfbuilder_Wrapper_Content15';
import Page_Acfbuilder_Wrapper_Content16 from 'components/Builder/Page_Acfbuilder_Wrapper_Content16/Page_Acfbuilder_Wrapper_Content16';
import Page_Acfbuilder_Wrapper_Content17 from 'components/Builder/Page_Acfbuilder_Wrapper_Content17/Page_Acfbuilder_Wrapper_Content17';
import Page_Acfbuilder_Wrapper_Content18 from 'components/Builder/Page_Acfbuilder_Wrapper_Content18/Page_Acfbuilder_Wrapper_Content18';
import Page_Acfbuilder_Wrapper_Content19 from 'components/Builder/Page_Acfbuilder_Wrapper_Content19/Page_Acfbuilder_Wrapper_Content19';
import Page_Acfbuilder_Wrapper_Content2 from 'components/Builder/Page_Acfbuilder_Wrapper_Content2/Page_Acfbuilder_Wrapper_Content2';
import Page_Acfbuilder_Wrapper_Content20 from 'components/Builder/Page_Acfbuilder_Wrapper_Content20/Page_Acfbuilder_Wrapper_Content20';
import Page_Acfbuilder_Wrapper_Content21 from 'components/Builder/Page_Acfbuilder_Wrapper_Content21/Page_Acfbuilder_Wrapper_Content21';
import Page_Acfbuilder_Wrapper_Content22 from 'components/Builder/Page_Acfbuilder_Wrapper_Content22/Page_Acfbuilder_Wrapper_Content22';
import Page_Acfbuilder_Wrapper_Content23 from 'components/Builder/Page_Acfbuilder_Wrapper_Content23/Page_Acfbuilder_Wrapper_Content23';
import Page_Acfbuilder_Wrapper_Content24 from 'components/Builder/Page_Acfbuilder_Wrapper_Content24/Page_Acfbuilder_Wrapper_Content24';
import Page_Acfbuilder_Wrapper_Content25 from 'components/Builder/Page_Acfbuilder_Wrapper_Content25/Page_Acfbuilder_Wrapper_Content25';
import Page_Acfbuilder_Wrapper_Content26 from 'components/Builder/Page_Acfbuilder_Wrapper_Content26/Page_Acfbuilder_Wrapper_Content26';
import Page_Acfbuilder_Wrapper_Content27 from 'components/Builder/Page_Acfbuilder_Wrapper_Content27/Page_Acfbuilder_Wrapper_Content27';
import Page_Acfbuilder_Wrapper_Content28 from 'components/Builder/Page_Acfbuilder_Wrapper_Content28/Page_Acfbuilder_Wrapper_Content28';
import Page_Acfbuilder_Wrapper_Content29 from 'components/Builder/Page_Acfbuilder_Wrapper_Content29/Page_Acfbuilder_Wrapper_Content29';
import Page_Acfbuilder_Wrapper_Content3 from 'components/Builder/Page_Acfbuilder_Wrapper_Content3/Page_Acfbuilder_Wrapper_Content3';
import Page_Acfbuilder_Wrapper_Content30 from 'components/Builder/Page_Acfbuilder_Wrapper_Content30/Page_Acfbuilder_Wrapper_Content30';
import Page_Acfbuilder_Wrapper_Content4 from 'components/Builder/Page_Acfbuilder_Wrapper_Content4/Page_Acfbuilder_Wrapper_Content4';
import Page_Acfbuilder_Wrapper_Content5 from 'components/Builder/Page_Acfbuilder_Wrapper_Content5/Page_Acfbuilder_Wrapper_Content5';
import Page_Acfbuilder_Wrapper_Content6 from 'components/Builder/Page_Acfbuilder_Wrapper_Content6/Page_Acfbuilder_Wrapper_Content6';
import Page_Acfbuilder_Wrapper_Content7 from 'components/Builder/Page_Acfbuilder_Wrapper_Content7/Page_Acfbuilder_Wrapper_Content7';
import Page_Acfbuilder_Wrapper_Content8 from 'components/Builder/Page_Acfbuilder_Wrapper_Content8/Page_Acfbuilder_Wrapper_Content8';
import Page_Acfbuilder_Wrapper_Content9 from 'components/Builder/Page_Acfbuilder_Wrapper_Content9/Page_Acfbuilder_Wrapper_Content9';
import Page_Acfbuilder_Wrapper_ContentCards1 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards1/Page_Acfbuilder_Wrapper_ContentCards1';
import Page_Acfbuilder_Wrapper_ContentCards2 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards2/Page_Acfbuilder_Wrapper_ContentCards2';
import Page_Acfbuilder_Wrapper_ContentCards3 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards3/Page_Acfbuilder_Wrapper_ContentCards3';
import Page_Acfbuilder_Wrapper_ContentCards4 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards4/Page_Acfbuilder_Wrapper_ContentCards4';
import Page_Acfbuilder_Wrapper_ContentCards5 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards5/Page_Acfbuilder_Wrapper_ContentCards5';
import Page_Acfbuilder_Wrapper_ContentCards6 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards6/Page_Acfbuilder_Wrapper_ContentCards6';
import Page_Acfbuilder_Wrapper_ContentCards7 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards7/Page_Acfbuilder_Wrapper_ContentCards7';
import Page_Acfbuilder_Wrapper_ContentCards8 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentCards8/Page_Acfbuilder_Wrapper_ContentCards8';
import Page_Acfbuilder_Wrapper_ContentList1 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentList1/Page_Acfbuilder_Wrapper_ContentList1';
import Page_Acfbuilder_Wrapper_ContentList2 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentList2/Page_Acfbuilder_Wrapper_ContentList2';
import Page_Acfbuilder_Wrapper_ContentLogos from 'components/Builder/Page_Acfbuilder_Wrapper_ContentLogos/Page_Acfbuilder_Wrapper_ContentLogos';
import Page_Acfbuilder_Wrapper_ContentText1 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentText1/Page_Acfbuilder_Wrapper_ContentText1';
import Page_Acfbuilder_Wrapper_ContentText2 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentText2/Page_Acfbuilder_Wrapper_ContentText2';
import Page_Acfbuilder_Wrapper_ContentText3 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentText3/Page_Acfbuilder_Wrapper_ContentText3';
import Page_Acfbuilder_Wrapper_ContentText4 from 'components/Builder/Page_Acfbuilder_Wrapper_ContentText4/Page_Acfbuilder_Wrapper_ContentText4';
import Page_Acfbuilder_Wrapper_Cta1 from 'components/Builder/Page_Acfbuilder_Wrapper_Cta1/Page_Acfbuilder_Wrapper_Cta1';
import Page_Acfbuilder_Wrapper_Cta2 from 'components/Builder/Page_Acfbuilder_Wrapper_Cta2/Page_Acfbuilder_Wrapper_Cta2';
import Page_Acfbuilder_Wrapper_Cta3 from 'components/Builder/Page_Acfbuilder_Wrapper_Cta3/Page_Acfbuilder_Wrapper_Cta3';
import Page_Acfbuilder_Wrapper_Cta4 from 'components/Builder/Page_Acfbuilder_Wrapper_Cta4/Page_Acfbuilder_Wrapper_Cta4';
import Page_Acfbuilder_Wrapper_CustomerStories from 'components/Builder/Page_Acfbuilder_Wrapper_CustomerStories/Page_Acfbuilder_Wrapper_CustomerStories';
import Page_Acfbuilder_Wrapper_Distributors from 'components/Builder/Page_Acfbuilder_Wrapper_Distributors/Page_Acfbuilder_Wrapper_Distributors';
import Page_Acfbuilder_Wrapper_DistributorsForm from 'components/Builder/Page_Acfbuilder_Wrapper_DistributorsForm/Page_Acfbuilder_Wrapper_DistributorsForm';
import Page_Acfbuilder_Wrapper_Documents from 'components/Builder/Page_Acfbuilder_Wrapper_Documents/Page_Acfbuilder_Wrapper_Documents';
import Page_Acfbuilder_Wrapper_Download from 'components/Builder/Page_Acfbuilder_Wrapper_Download/Page_Acfbuilder_Wrapper_Download';
import Page_Acfbuilder_Wrapper_EksoEvo from 'components/Builder/Page_Acfbuilder_Wrapper_EksoEvo/Page_Acfbuilder_Wrapper_EksoEvo';
import Page_Acfbuilder_Wrapper_EksoEvoFeatures from 'components/Builder/Page_Acfbuilder_Wrapper_EksoEvoFeatures/Page_Acfbuilder_Wrapper_EksoEvoFeatures';
import Page_Acfbuilder_Wrapper_EksoIndergoPersonalFeatures from 'components/Builder/Page_Acfbuilder_Wrapper_EksoIndergoPersonalFeatures/Page_Acfbuilder_Wrapper_EksoIndergoPersonalFeatures';
import Page_Acfbuilder_Wrapper_EksoIndergoTherapyFeatures from 'components/Builder/Page_Acfbuilder_Wrapper_EksoIndergoTherapyFeatures/Page_Acfbuilder_Wrapper_EksoIndergoTherapyFeatures';
import Page_Acfbuilder_Wrapper_EksoNrFeatures from 'components/Builder/Page_Acfbuilder_Wrapper_EksoNrFeatures/Page_Acfbuilder_Wrapper_EksoNrFeatures';
import Page_Acfbuilder_Wrapper_Faq from 'components/Builder/Page_Acfbuilder_Wrapper_Faq/Page_Acfbuilder_Wrapper_Faq';
import Page_Acfbuilder_Wrapper_FaqsSections from 'components/Builder/Page_Acfbuilder_Wrapper_FaqsSections/Page_Acfbuilder_Wrapper_FaqsSections';
import Page_Acfbuilder_Wrapper_Hero from 'components/Builder/Page_Acfbuilder_Wrapper_Hero/Page_Acfbuilder_Wrapper_Hero';
import Page_Acfbuilder_Wrapper_HeroHome from 'components/Builder/Page_Acfbuilder_Wrapper_HeroHome/Page_Acfbuilder_Wrapper_HeroHome';
import Page_Acfbuilder_Wrapper_HeroLogo from 'components/Builder/Page_Acfbuilder_Wrapper_HeroLogo/Page_Acfbuilder_Wrapper_HeroLogo';
import Page_Acfbuilder_Wrapper_HeroVideo from 'components/Builder/Page_Acfbuilder_Wrapper_HeroVideo/Page_Acfbuilder_Wrapper_HeroVideo';
import Page_Acfbuilder_Wrapper_Highlight1 from 'components/Builder/Page_Acfbuilder_Wrapper_Highlight1/Page_Acfbuilder_Wrapper_Highlight1';
import Page_Acfbuilder_Wrapper_Highlight2 from 'components/Builder/Page_Acfbuilder_Wrapper_Highlight2/Page_Acfbuilder_Wrapper_Highlight2';
import Page_Acfbuilder_Wrapper_Highlight3 from 'components/Builder/Page_Acfbuilder_Wrapper_Highlight3/Page_Acfbuilder_Wrapper_Highlight3';
import Page_Acfbuilder_Wrapper_Industry from 'components/Builder/Page_Acfbuilder_Wrapper_Industry/Page_Acfbuilder_Wrapper_Industry';
import Page_Acfbuilder_Wrapper_Investor from 'components/Builder/Page_Acfbuilder_Wrapper_Investor/Page_Acfbuilder_Wrapper_Investor';
import Page_Acfbuilder_Wrapper_Jobs from 'components/Builder/Page_Acfbuilder_Wrapper_Jobs/Page_Acfbuilder_Wrapper_Jobs';
import Page_Acfbuilder_Wrapper_Map from 'components/Builder/Page_Acfbuilder_Wrapper_Map/Page_Acfbuilder_Wrapper_Map';
import Page_Acfbuilder_Wrapper_NewsAndEvents from 'components/Builder/Page_Acfbuilder_Wrapper_NewsAndEvents/Page_Acfbuilder_Wrapper_NewsAndEvents';
import Page_Acfbuilder_Wrapper_NewsWidget from 'components/Builder/Page_Acfbuilder_Wrapper_NewsWidget/Page_Acfbuilder_Wrapper_NewsWidget';
import Page_Acfbuilder_Wrapper_Offices from 'components/Builder/Page_Acfbuilder_Wrapper_Offices/Page_Acfbuilder_Wrapper_Offices';
import Page_Acfbuilder_Wrapper_Patents from 'components/Builder/Page_Acfbuilder_Wrapper_Patents/Page_Acfbuilder_Wrapper_Patents';
import Page_Acfbuilder_Wrapper_Privacy from 'components/Builder/Page_Acfbuilder_Wrapper_Privacy/Page_Acfbuilder_Wrapper_Privacy';
import Page_Acfbuilder_Wrapper_ReferenceCenters from 'components/Builder/Page_Acfbuilder_Wrapper_ReferenceCenters/Page_Acfbuilder_Wrapper_ReferenceCenters';
import Page_Acfbuilder_Wrapper_RequestForm from 'components/Builder/Page_Acfbuilder_Wrapper_RequestForm/Page_Acfbuilder_Wrapper_RequestForm';
import Page_Acfbuilder_Wrapper_Research from 'components/Builder/Page_Acfbuilder_Wrapper_Research/Page_Acfbuilder_Wrapper_Research';
import Page_Acfbuilder_Wrapper_Resources from 'components/Builder/Page_Acfbuilder_Wrapper_Resources/Page_Acfbuilder_Wrapper_Resources';
import Page_Acfbuilder_Wrapper_Specifications from 'components/Builder/Page_Acfbuilder_Wrapper_Specifications/Page_Acfbuilder_Wrapper_Specifications';
import Page_Acfbuilder_Wrapper_Team from 'components/Builder/Page_Acfbuilder_Wrapper_Team/Page_Acfbuilder_Wrapper_Team';
import Page_Acfbuilder_Wrapper_Terms from 'components/Builder/Page_Acfbuilder_Wrapper_Terms/Page_Acfbuilder_Wrapper_Terms';
import Page_Acfbuilder_Wrapper_Testimonials1 from 'components/Builder/Page_Acfbuilder_Wrapper_Testimonials1/Page_Acfbuilder_Wrapper_Testimonials1';
import Page_Acfbuilder_Wrapper_Testimonials2 from 'components/Builder/Page_Acfbuilder_Wrapper_Testimonials2/Page_Acfbuilder_Wrapper_Testimonials2';
import Page_Acfbuilder_Wrapper_Tools from 'components/Builder/Page_Acfbuilder_Wrapper_Tools/Page_Acfbuilder_Wrapper_Tools';
import Page_Acfbuilder_Wrapper_Typ from 'components/Builder/Page_Acfbuilder_Wrapper_Typ/Page_Acfbuilder_Wrapper_Typ';
import Page_Acfbuilder_Wrapper_WebinarWidget from 'components/Builder/Page_Acfbuilder_Wrapper_WebinarWidget/Page_Acfbuilder_Wrapper_WebinarWidget';
import Page_Acfbuilder_Wrapper_Webinars from 'components/Builder/Page_Acfbuilder_Wrapper_Webinars/Page_Acfbuilder_Wrapper_Webinars';
import Seo from 'components/seo';
import { graphql } from 'gatsby';
import React from 'react';
import Layout from '../components/layout';
import Page_Acfbuilder_Wrapper_Cards from 'components/Builder/Page_acfbuilder_Wrapper_Cards/Page_Acfbuilder_Wrapper_Cards';
import Page_acfbuilder_Wrapper_Accordion from 'components/Builder/Page_Acfbuilder_wrapper_Accordion/Page_acfbuilder_Wrapper_Accordion';

const HomepageTemplate = ({ data }) => {
  const { wrapper } = data?.wpPage?.ACFbuilder ?? {};
  const { title, metaDesc } = data?.wpPage?.seo ?? {};
  const { uri, language, translations } = data?.wpPage ?? {};

  return (
    <div className='canvas'>
      <Layout>
        <Seo
          title={title}
          description={metaDesc}
          pageuri={uri}
          pagetransuri={translations && translations[0]?.uri}
          pagelang={language?.slug}
          pagetranslang={translations && translations[0]?.language?.slug}
        />
        {wrapper?.map((section, index) => {
          switch (section.fieldGroupName) {
            case 'Page_Acfbuilder_Wrapper_HeroHome':
              return (
                <Page_Acfbuilder_Wrapper_HeroHome key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Hero':
              return (
                <Page_Acfbuilder_Wrapper_Hero key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_HeroLogo':
              return (
                <Page_Acfbuilder_Wrapper_HeroLogo key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_HeroVideo':
              return (
                <Page_Acfbuilder_Wrapper_HeroVideo key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content1':
              return (
                <Page_Acfbuilder_Wrapper_Content1 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content2':
              return (
                <Page_Acfbuilder_Wrapper_Content2 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content3':
              return (
                <Page_Acfbuilder_Wrapper_Content3 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content4':
              return (
                <Page_Acfbuilder_Wrapper_Content4 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content5':
              return (
                <Page_Acfbuilder_Wrapper_Content5 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content6':
              return (
                <Page_Acfbuilder_Wrapper_Content6 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content7':
              return (
                <Page_Acfbuilder_Wrapper_Content7 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content8':
              return (
                <Page_Acfbuilder_Wrapper_Content8 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content9':
              return (
                <Page_Acfbuilder_Wrapper_Content9 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content10':
              return (
                <Page_Acfbuilder_Wrapper_Content10 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content11':
              return (
                <Page_Acfbuilder_Wrapper_Content11 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content12':
              return (
                <Page_Acfbuilder_Wrapper_Content12 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content13':
              return (
                <Page_Acfbuilder_Wrapper_Content13 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content14':
              return (
                <Page_Acfbuilder_Wrapper_Content14 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content15':
              return (
                <Page_Acfbuilder_Wrapper_Content15 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content16':
              return (
                <Page_Acfbuilder_Wrapper_Content16 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content17':
              return (
                <Page_Acfbuilder_Wrapper_Content17 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content18':
              return (
                <Page_Acfbuilder_Wrapper_Content18 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content19':
              return (
                <Page_Acfbuilder_Wrapper_Content19 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content20':
              return (
                <Page_Acfbuilder_Wrapper_Content20 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content21':
              return (
                <Page_Acfbuilder_Wrapper_Content21 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content22':
              return (
                <Page_Acfbuilder_Wrapper_Content22 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content23':
              return (
                <Page_Acfbuilder_Wrapper_Content23 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content24':
              return (
                <Page_Acfbuilder_Wrapper_Content24 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content25':
              return (
                <Page_Acfbuilder_Wrapper_Content25 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content26':
              return (
                <Page_Acfbuilder_Wrapper_Content26 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content27':
              return (
                <Page_Acfbuilder_Wrapper_Content27 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content28':
              return (
                <Page_Acfbuilder_Wrapper_Content28 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content29':
              return (
                <Page_Acfbuilder_Wrapper_Content29 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Content30':
              return (
                <Page_Acfbuilder_Wrapper_Content30 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards1':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards1
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards2':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards2
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards3':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards3
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards4':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards4
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards5':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards5
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards6':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards6
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards7':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards7
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentCards8':
              return (
                <Page_Acfbuilder_Wrapper_ContentCards8
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentText1':
              return (
                <Page_Acfbuilder_Wrapper_ContentText1
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentText2':
              return (
                <Page_Acfbuilder_Wrapper_ContentText2
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentText3':
              return (
                <Page_Acfbuilder_Wrapper_ContentText3
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentText4':
              return (
                <Page_Acfbuilder_Wrapper_ContentText4
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentList1':
              return (
                <Page_Acfbuilder_Wrapper_ContentList1
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContentList2':
              return (
                <Page_Acfbuilder_Wrapper_ContentList2
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Cta1':
              return (
                <Page_Acfbuilder_Wrapper_Cta1 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Cta2':
              return (
                <Page_Acfbuilder_Wrapper_Cta2 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Cta3':
              return (
                <Page_Acfbuilder_Wrapper_Cta3 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Cta4':
              return (
                <Page_Acfbuilder_Wrapper_Cta4 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Highlight1':
              return (
                <Page_Acfbuilder_Wrapper_Highlight1
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Highlight2':
              return (
                <Page_Acfbuilder_Wrapper_Highlight2
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Highlight3':
              return (
                <Page_Acfbuilder_Wrapper_Highlight3
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Specifications':
              return (
                <Page_Acfbuilder_Wrapper_Specifications
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Download':
              return (
                <Page_Acfbuilder_Wrapper_Download key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Research':
              return (
                <Page_Acfbuilder_Wrapper_Research key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_NewsWidget':
              return (
                <Page_Acfbuilder_Wrapper_NewsWidget
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_BlogWidget1':
              return (
                <Page_Acfbuilder_Wrapper_BlogWidget1
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_BlogWidget2':
              return (
                <Page_Acfbuilder_Wrapper_BlogWidget2
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_WebinarWidget':
              return (
                <Page_Acfbuilder_Wrapper_WebinarWidget
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_About':
              return (
                <Page_Acfbuilder_Wrapper_About key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Team':
              return (
                <Page_Acfbuilder_Wrapper_Team key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_EksoEvo':
              return (
                <Page_Acfbuilder_Wrapper_EksoEvo key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_EksoNrFeatures':
              return (
                <Page_Acfbuilder_Wrapper_EksoNrFeatures
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_EksoEvoFeatures':
              return (
                <Page_Acfbuilder_Wrapper_EksoEvoFeatures
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_EksoIndergoTherapyFeatures':
              return (
                <Page_Acfbuilder_Wrapper_EksoIndergoTherapyFeatures
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_EksoIndergoPersonalFeatures':
              return (
                <Page_Acfbuilder_Wrapper_EksoIndergoPersonalFeatures
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Testimonials1':
              return (
                <Page_Acfbuilder_Wrapper_Testimonials1
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Testimonials2':
              return (
                <Page_Acfbuilder_Wrapper_Testimonials2
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Faq':
              return <Page_Acfbuilder_Wrapper_Faq key={index} data={section} />;
            case 'Page_Acfbuilder_Wrapper_NewsAndEvents':
              return (
                <Page_Acfbuilder_Wrapper_NewsAndEvents
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Jobs':
              return (
                <Page_Acfbuilder_Wrapper_Jobs key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Resources':
              return (
                <Page_Acfbuilder_Wrapper_Resources key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_CustomerStories':
              return (
                <Page_Acfbuilder_Wrapper_CustomerStories
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_CentersOfExcellence':
              return (
                <Page_Acfbuilder_Wrapper_CentersOfExcellence
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ReferenceCenters':
              return (
                <Page_Acfbuilder_Wrapper_ReferenceCenters
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Distributors':
              return (
                <Page_Acfbuilder_Wrapper_Distributors
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_DistributorsForm':
              return (
                <Page_Acfbuilder_Wrapper_DistributorsForm
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_ContactForm':
              return (
                <Page_Acfbuilder_Wrapper_ContactForm
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_RequestForm':
              return (
                <Page_Acfbuilder_Wrapper_RequestForm
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Offices':
              return (
                <Page_Acfbuilder_Wrapper_Offices key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Investor':
              return (
                <Page_Acfbuilder_Wrapper_Investor key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_ContentLogos':
              return (
                <Page_Acfbuilder_Wrapper_ContentLogos
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Tools':
              return (
                <Page_Acfbuilder_Wrapper_Tools key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Industry':
              return (
                <Page_Acfbuilder_Wrapper_Industry key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Terms':
              return (
                <Page_Acfbuilder_Wrapper_Terms key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Webinars':
              return (
                <Page_Acfbuilder_Wrapper_Webinars key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Clean':
              return (
                <Page_Acfbuilder_Wrapper_Clean key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Contact1':
              return (
                <Page_Acfbuilder_Wrapper_Contact1 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Contact2':
              return (
                <Page_Acfbuilder_Wrapper_Contact2 key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_FaqsSections':
              return (
                <Page_Acfbuilder_Wrapper_FaqsSections
                  key={index}
                  data={section}
                />
              );
            case 'Page_Acfbuilder_Wrapper_Typ':
              return <Page_Acfbuilder_Wrapper_Typ key={index} data={section} />;
            case 'Page_Acfbuilder_Wrapper_Map':
              return <Page_Acfbuilder_Wrapper_Map key={index} data={section} />;
            case 'Page_Acfbuilder_Wrapper_Privacy':
              return (
                <Page_Acfbuilder_Wrapper_Privacy key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Patents':
              return (
                <Page_Acfbuilder_Wrapper_Patents key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Documents':
              return (
                <Page_Acfbuilder_Wrapper_Documents key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Blog':
              return (
                <Page_Acfbuilder_Wrapper_Blog key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Cards':
              return (
                <Page_Acfbuilder_Wrapper_Cards key={index} data={section} />
              );
            case 'Page_Acfbuilder_Wrapper_Accordion':
              return (
                <Page_acfbuilder_Wrapper_Accordion key={index} data={section} />
              );
            default:
              return <React.Fragment key={index}></React.Fragment>;
          }
        })}
      </Layout>
    </div>
  );
};

export default HomepageTemplate;

export const pageQuery = graphql`
  query ($language: String!) {
    wpPage(language: { slug: { eq: $language } }, isFrontPage: { eq: true }) {
      seo {
        title
        metaDesc
      }
      uri
      language {
        slug
      }
      translations {
        uri
        language {
          slug
        }
      }
      ACFbuilder {
        wrapper {
          ... on WpPage_Acfbuilder_Wrapper_HeroHome {
            fieldGroupName
            heroHomeButtonText
            heroHomeButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            heroHomeImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            heroHomeLogos {
              heroLogo {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
            heroHomeTitle
            heroHomeVideo {
              localFile {
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content1 {
            fieldGroupName
            content1ButtonText
            content1Heading
            content1ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content1Title
            content1Text
            content1Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content2 {
            fieldGroupName
            content2Heading
            content2Text
            content2Title
            content2Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content3 {
            fieldGroupName
            content3ButtonText
            content3Heading
            content3ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content3Title
            content3Text
            content3Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content4 {
            fieldGroupName
            content4ButtonText
            content4Heading
            content4ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content4Text
            content4Title
            content4Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content5 {
            fieldGroupName
            content5Text
            content5Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content5ButtonText
            content5ButtonFile {
              localFile {
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content6 {
            fieldGroupName
            content6Heading
            content6Text
            content6Title
            content6Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content7 {
            fieldGroupName
            content7ButtonText
            content7Heading
            content7Title
            content7Text
            content7ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content7Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content8 {
            fieldGroupName
            content8ButtonLink
            content8ButtonText
            content8Heading
            content8Text
            content8Title
            content8Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content9 {
            fieldGroupName
            content9ButtonText
            content9Heading
            content9Title
            content9Text
            content9ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content9Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content10 {
            fieldGroupName
            content10ButtonText
            content10Heading
            content10Title
            content10Text
            content10ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content10Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content11 {
            fieldGroupName
            content11ButtonLinkType
            content11ButtonText
            content11ButtonFileLink {
              localFile {
                publicURL
              }
            }
            content11ButtonPageLink {
              ... on WpPage {
                id
                uri
              }
            }
            content11Heading
            content11Text
            content11Title
            content11Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content12 {
            fieldGroupName
            content12ButtonText
            content12Heading
            content12Text
            content12Title
            content12ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content12VideoUrl
          }
          ... on WpPage_Acfbuilder_Wrapper_Content13 {
            fieldGroupName
            content13ButtonText
            content13Heading
            content13ButtonLink {
              ... on WpPost {
                id
                uri
              }
              ... on WpPage {
                id
                uri
              }
            }
            content13Text
            content13Title
            content13Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content14 {
            fieldGroupName
            content14Heading
            content14Text
            content14Title
            content14Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content15 {
            fieldGroupName
            content15Heading
            content15ListTitle
            content15Title
            content15Text
            content15Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content15List {
              content15ListItem
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content16 {
            fieldGroupName
            content16Heading
            content16Text
            content16Title
            content16Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content17 {
            fieldGroupName
            content17ButtonText
            content17Text
            content17Title
            content17ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content17Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content17Logo {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content18 {
            fieldGroupName
            content18Heading
            content18Text
            content18Title
            content18Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content18ButtonText
            content18ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content19 {
            fieldGroupName
            content19Text
            content19Title
            content19VideoUrl
            content19Background {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content20 {
            fieldGroupName
            content20FbLink
            content20Heading
            content20Text
            content20Title
            content20TwitterLink
            content20InstagramLink
            content20Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content21 {
            fieldGroupName
            content21Heading
            content21Text
            content21Title
            content21Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content22 {
            fieldGroupName
            content22ButtonText
            content22Heading
            content22ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content22Text
            content22Title
            content22Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content23 {
            fieldGroupName
            content23ButtonText
            content23Text
            content23Title
            content23ButtonFile {
              localFile {
                publicURL
              }
            }
            content23Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content24 {
            fieldGroupName
            content24Heading
            content24LeftText
            content24Title
            content24RightText
            content24LeftImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content24RightImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content25 {
            fieldGroupName
            content25ButtonText
            content25Heading
            content25ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content25Title
            content25Text
            content25Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content26 {
            fieldGroupName
            content26ButtonText
            content26Heading
            content26Title
            content26Text
            content26ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            content26Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content27 {
            fieldGroupName
            content27RightText
            content27LeftHeading
            content27RightTitle
            content27LeftText
            content27LeftTitle
            content27RightHeading
            content27LeftImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content27RightImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content28 {
            fieldGroupName
            content28Heading
            content28SectionTitle
            content28Title
            content28Text
            content28Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content29 {
            fieldGroupName
            content29ButtonLink
            content29ButtonText
            content29Title
            content29Text
            content29Heading
            content29Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content29Logo {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Content30 {
            fieldGroupName
            content30ButtonLink
            content30ButtonText
            content30Heading
            content30Text
            content30Title
            content30Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            content30Logo {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards1 {
            fieldGroupName
            contentCard1BottomText
            contentCards1Heading
            contentCards1Title
            contentCards1Text
            contentCards1Cards {
              contentCards1CardTitle
              contentCards1CardText
              contentCards1CardIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards2 {
            fieldGroupName
            contentCards2Cards {
              contentCards2CardTitle
              contentCards2CardText
              contentCards2CardIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards3 {
            fieldGroupName
            contentCards3Heading
            contentCards3Title
            contentCards3Cards {
              contentCards3CardText
              contentCards3CardTitle
              contentCards3CardIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards4 {
            fieldGroupName
            contentCards4Heading
            contentCards4Text
            contentCards4Title
            contentCards4Cards {
              contentCards4CardTitle
              contentCards4CardText
              contentCards4CardIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards5 {
            fieldGroupName
            contentCards5Heading
            contentCards5Text
            contentCards5Cards {
              contentCards5CardTitle
              contentCards5CardText
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards6 {
            fieldGroupName
            contentCards6Heading
            contentCards6Title
            contentCards6Cards {
              contentCards6CardLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              contentCards6CardUrl
              contentCards6CardLinkType
              contentCards6CardImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards7 {
            fieldGroupName
            contentCards7Heading
            contentCards7Text
            contentCards7Title
            contentCards7Cards {
              contentCards7CardText
              contentCards7CardTitle
              contentCards7CardIcon {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
            contentCards7Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentCards8 {
            fieldGroupName
            contentCards8Heading
            contentCards8Title
            contentCards8Cards {
              contentCards8CardTitle
              contentCards8CardText
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentText1 {
            fieldGroupName
            contentText1ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            contentText1ButtonText
            contentText1Heading
            contentText1Text
            contentText1Title
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentText2 {
            fieldGroupName
            contentText2Heading
            contentText2LeftText
            contentText2RightText
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentText3 {
            fieldGroupName
            contentText3Heading
            contentText3Text
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentText4 {
            fieldGroupName
            contentText4Heading
            contentText4Text
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentList1 {
            fieldGroupName
            contentList1Heading
            contentList1Title
            contentList1List
            contentList1Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentList2 {
            fieldGroupName
            contentList2Heading
            contentList2Title
            contentList2Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            contentList2List {
              contentList2Item
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Cta1 {
            fieldGroupName
            cta1ButtonText
            cta1ButtonType
            cta1ButtonPageLink {
              ... on WpPage {
                id
                uri
              }
            }
            cta1ButtonUrlLink
            cta1Heading
            cta1Text
            cta1Title
          }
          ... on WpPage_Acfbuilder_Wrapper_Cta2 {
            fieldGroupName
            cta2ButtonText
            cta2Heading
            cta2ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            cta2Text
            cta2Title
          }
          ... on WpPage_Acfbuilder_Wrapper_Cta3 {
            fieldGroupName
            cta3Heading
            cta3Title
            cta3Text
            cta3ButtonText
            cta3ButtonLink
          }
          ... on WpPage_Acfbuilder_Wrapper_Cta4 {
            fieldGroupName
            cta4Heading
            cta4Title
            cta4Text
            cta4ButtonText
            cta4ButtonLink
            cta4VideoUrl
            cta4VideoSubtext
          }
          ... on WpPage_Acfbuilder_Wrapper_Highlight1 {
            fieldGroupName
            highlight1ButtonLinkType
            highlight1ButtonPageLink {
              ... on WpPage {
                id
                uri
              }
            }
            highlight1ButtonFile {
              localFile {
                publicURL
              }
            }
            highlight1ButtonText
            highlight1Heading
            highlight1Text
            highlight1Title
            highlight1Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Highlight2 {
            fieldGroupName
            highlight2ButtonLinkType
            highlight2ButtonPageLink {
              ... on WpPage {
                id
                uri
              }
            }
            highlight2ButtonText
            highlight2ButtonTextLink
            highlight2ButtonUrlLink
            highlight2Heading
            highlight2Title
            highlight2IsOverlay
            highlight2Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Highlight3 {
            fieldGroupName
            highlight3ButtonLink
            highlight3ButtonText
            highlight3Heading
            highlight3Title
            highlight3Image {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Specifications {
            fieldGroupName
            specificationsButtonText
            specificationsHeading
            specificationsText
            specificationsTitle
            specificationsButtonFile {
              localFile {
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Download {
            fieldGroupName
            downloadButtonText
            downloadTitle
            downloadButtonFile {
              localFile {
                publicURL
              }
              filename
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Research {
            fieldGroupName
            researchButtonText
            researchButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            researchHeading
            researchText
            researchTitle
          }
          ... on WpPage_Acfbuilder_Wrapper_NewsWidget {
            fieldGroupName
            newsWidgetButtonText
            newsWidgetButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            newsWidgetHeading
            newsWidgetText
          }
          ... on WpPage_Acfbuilder_Wrapper_BlogWidget1 {
            fieldGroupName
            blogWidget1ButtonText
            blogWidget1Heading
            blogWidget1ButtonLink {
              ... on WpPage {
                id
                uri
              }
            }
            blogWidget1Text
            blogWidget1Title
          }
          ... on WpPage_Acfbuilder_Wrapper_BlogWidget2 {
            fieldGroupName
            blogWidget2Heading
            blogWidget2Title
          }
          ... on WpPage_Acfbuilder_Wrapper_WebinarWidget {
            fieldGroupName
            webinarWidgetButtonLink
            webinarWidgetButtonText
            webinarWidgetHeading
            webinarWidgetText
            webinarWidgetTitle
            webinarWidgetImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_About {
            fieldGroupName
            aboutHeading
            aboutText
            aboutTitle
            aboutVideoId
          }
          ... on WpPage_Acfbuilder_Wrapper_Team {
            fieldGroupName
            teamHeading
            teamTitle
            team {
              teamLinkedinLink
              teamName
              teamPosition
              teamText
              teamImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_EksoEvo {
            fieldGroupName
            eksoEvoButtonLink
            eksoEvoButtonText
            eksoEvoHeading
            eksoEvoText
            eksoEvoTitle
            eksoEvoImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_EksoEvoFeatures {
            fieldGroupName
            eksoEvoFeaturesHeading
            eksoEvoFeaturesTitle
            eksoEvoFeatures {
              eksoEvoFeatureText
              eksoEvoFeatureTitle
            }
            eksoEvoFeaturesImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_EksoNrFeatures {
            fieldGroupName
            eksoNrFeaturesHeading
            eksoNrFeaturesTitle
            eksoNrFeatures {
              eksoNrFeatureText
              eksoNrFeatureTitle
            }
            eksoNrFeaturesImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_EksoIndergoTherapyFeatures {
            fieldGroupName
            eksoIndergoTherapyFeatures {
              eksoIndergoTherapyFeatureTitle
              eksoIndergoTherapyFeatureText
            }
            eksoIndergoTherapyFeaturesHeading
            eksoIndergoTherapyFeaturesTitle
            eksoIndergoTherapyFeaturesImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_EksoIndergoPersonalFeatures {
            fieldGroupName
            eksoIndergoPersonalFeaturesHeading
            eksoIndergoPersonalFeaturesTitle
            eksoIndergoPersonalFeatures {
              eksoIndergoPersonalFeatureTitle
              eksoIndergoPersonalFeatureText
            }
            eksoIndergoPersonalFeaturesImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Testimonials1 {
            fieldGroupName
            testimonials1 {
              testimonial1Name
              testimonial1Position
              testimonial1Text
              testimonial1Image {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Testimonials2 {
            fieldGroupName
            testimonials2 {
              testimonial2Name
              testimonial2Position
              testimonial2Text
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Faq {
            fieldGroupName
            faqsTitle
            faqs {
              faqQuestion
              faqAnswer
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_NewsAndEvents {
            fieldGroupName
            events {
              eventDate
              eventLink
              eventTitle
              eventType
              eventImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
            news {
              newsTitle
              newsLink
              newsDate
              newsImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Jobs {
            fieldGroupName
            jobsHeading
            jobsTitle
            jobs {
              jobTitle
              jobDescription
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Resources {
            fieldGroupName
            resourcesHeading
            resourcesTitle
            resourcesText
            resources {
              resourceButtonLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              resourceButtonText
              resourceLink
              resourceText
              resourceTitle
              resourceImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_CustomerStories {
            fieldGroupName
            customerStories {
              customerStoriesBlockTitle
              customerStoriesBlock {
                customerStoryLink
                customerStoryTitle
                customerStoryImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_CentersOfExcellence {
            fieldGroupName
            centersOfExcellenceText
            centersOfExcellenceTitle
            centersOfExcellence {
              centerOfExcellenceButtonLink
              centerOfExcellenceButtonText
              centerOfExcellenceHeading
              centerOfExcellenceText
              centerOfExcellenceTitle
              centerOfExcellenceImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_ReferenceCenters {
            fieldGroupName
            referenceCentersTitle
            referenceCenters {
              referenceCenterText
              referenceCenterTitle
              referenceCenterImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Distributors {
            fieldGroupName
            distributorsRegion {
              regionTitle
              regionDistributors {
                distributorEmail
                distributorText
                distributorWebsite
                distributorLogo {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                    publicURL
                  }
                }
              }
            }
            regionLinks {
              regionName
              regionLink
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_DistributorsForm {
            fieldGroupName
            distributorsFormText
            distributorsFormTitle
            distributorsFormFormId
            distributorsFormPortalId
          }
          ... on WpPage_Acfbuilder_Wrapper_ContactForm {
            fieldGroupName
            contactFormEmail
            contactFormTel
            contactFormTitle
            contactFormFormId
            contactFormPortalId
          }
          ... on WpPage_Acfbuilder_Wrapper_RequestForm {
            fieldGroupName
            requestFormTitle
            requestFormPortalId
            requestFormFormId
          }
          ... on WpPage_Acfbuilder_Wrapper_Offices {
            fieldGroupName
            officesTitle
            offices {
              officeDetails
              officeTel
              officeTitle
              officeImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Investor {
            fieldGroupName
            investorEmail
            investorPressEmail
            investorPressText
            investorPressTitle
            investorTel
            investorName
            investorTitle
          }
          ... on WpPage_Acfbuilder_Wrapper_ContentLogos {
            fieldGroupName
            contentLogos {
              contentLogo {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Tools {
            fieldGroupName
            toolsTitle
            tools {
              toolTitle
              toolText
              toolImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Industry {
            fieldGroupName
            industryButtonLink
            industryTitle
            industryText
            industryHeading
            industryButtonText
            industryBackgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Terms {
            fieldGroupName
            termsText
          }
          ... on WpPage_Acfbuilder_Wrapper_Webinars {
            fieldGroupName
            webinarsHeading
            webinarsTitle
            webinars {
              webinarTitle
              webinarLink
              webinarImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Clean {
            fieldGroupName
            cleanText
            fieldGroupName
          }
          ... on WpPage_Acfbuilder_Wrapper_Contact1 {
            fieldGroupName
            contact1Email
            contact1Phone
            contact1Title
          }
          ... on WpPage_Acfbuilder_Wrapper_Contact2 {
            fieldGroupName
            contact2Address
            contact2AddressTitle
            contact2Email
            contact2EmailTitle
            contact2Phone
            contact2PhoneTitle
            contact2Text
            contact2Title
          }
          ... on WpPage_Acfbuilder_Wrapper_FaqsSections {
            fieldGroupName
            faqsSections {
              faqTitle
              faqs {
                faqsAnswer
                faqsQuestion
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Typ {
            fieldGroupName
            typText
            typTitle
          }
          ... on WpPage_Acfbuilder_Wrapper_Map {
            fieldGroupName
            mapLink
            mapText
            mapTitle
          }
          ... on WpPage_Acfbuilder_Wrapper_Privacy {
            fieldGroupName
            privacyText
          }
          ... on WpPage_Acfbuilder_Wrapper_Patents {
            fieldGroupName
            patents {
              patentButtonLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              patentButtonText
              patentCodes
              patentHeading
              patentTitle
              patentImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Documents {
            fieldGroupName
            documents {
              documentTitle
              documentFile {
                localFile {
                  publicURL
                }
                filename
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Hero {
            fieldGroupName
            heroHeading
            heroText
            heroTitle
            heroImagePosition
            heroImage {
              localFile {
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_HeroLogo {
            fieldGroupName
            heroLogoText
            heroLogoTitle
            heroLogoVideoUrl
            heroLogoImagePosition
            heroLogo {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            heroLogoImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            heroLogoVideo {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_HeroVideo {
            fieldGroupName
            heroVideoPosition
            heroVideoUrl
            heroVideoTitle
            heroVideoText
            heroVideoImagePosition
            heroVideoImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
            heroVideoPoster {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Blog {
            fieldGroupName
          }
          ... on WpPage_Acfbuilder_Wrapper_Cards {
            cardsSubtitle
            cardsTitle
            fieldGroupName
            cardsCards {
              fieldGroupName
              cardsCardTitle
              cardsCardText
              cardLink {
                url
              }
              cardsCardImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                  publicURL  
                }
              }
            }
          }
          ... on WpPage_Acfbuilder_Wrapper_Accordion {
            accordionButtonText
            accordionSubtitle
            fieldGroupName
            accordionTitle
            accordionButtonLink {
              url
            }
            accordionImage {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            acordionAccordion {
              fieldGroupName
              accordionAccordionText
              accordionAccordionTitle
              accordionAccordionImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
